import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import TelegramGroupCard from "@/components/TelegramGroupCard";
import { Calendar, Mail, LogOut, Monitor } from "lucide-react";

export default function Settings() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/participant/me");
        setMe(data);
      } catch (_) {
        // ignore
      }
    })();
  }, []);

  const logout = async () => {
    try {
      await api.post("/participant/logout");
    } catch (_) {
      // ignore
    }
    localStorage.removeItem("participant_token");
    localStorage.removeItem("participant_email");
    localStorage.removeItem("participant_session_id");
    navigate("/login");
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <div className="text-[11px] uppercase tracking-[0.3em] text-amber-500/80 font-semibold mb-2">Profil</div>
        <h1 className="font-display text-4xl font-bold">Tetapan Akaun</h1>
      </div>

      <div className="bg-[#101010] border border-white/10 rounded-xl divide-y divide-white/10">
        <Row icon={<Mail size={18} />} label="Emel" value={me?.email || localStorage.getItem("participant_email")} testId="settings-email" />
        <Row
          icon={<Calendar size={18} />}
          label="Tarikh Tamat Akses"
          value={me?.expiry_date || (me ? "∞ Selamanya" : "—")}
          testId="settings-expiry"
        />
        <Row
          icon={<Monitor size={18} />}
          label="Sesi Aktif"
          value={me?.session_id ? me.session_id.slice(0, 12) + "…" : "—"}
          testId="settings-session"
          mono
        />
      </div>

      <div className="mt-6">
        <TelegramGroupCard />
      </div>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        <a
          href="/transactions"
          className="flex items-center justify-center gap-2 px-5 py-3 rounded-md border border-white/10 text-neutral-300 hover:bg-white/5 transition-colors"
          data-testid="settings-tx-link"
        >
          <Monitor size={16} /> Sejarah Transaksi
        </a>
        <button
          onClick={logout}
          className="flex items-center justify-center gap-2 px-5 py-3 rounded-md border border-red-500/30 text-red-400 hover:bg-red-500/10 transition-colors"
          data-testid="settings-logout-btn"
        >
          <LogOut size={16} /> Log Keluar Peranti Ini
        </button>
      </div>
    </div>
  );
}

function Row({ icon, label, value, testId, mono }) {
  return (
    <div className="flex items-center gap-4 px-6 py-5" data-testid={testId}>
      <div className="text-amber-500/80">{icon}</div>
      <div className="flex-1">
        <div className="text-xs text-neutral-500 uppercase tracking-wider font-mono">{label}</div>
        <div className={`text-white ${mono ? "font-mono text-sm" : ""}`}>{value || "—"}</div>
      </div>
    </div>
  );
}
